import LayoutV2 from 'components/common/LayoutV2';
import MarketplaceIntro from 'components/community/gridV2/MarketplaceIntro';
import CommunityView from 'components/community/gridV2/CommunityView';

export default function LatestCommunityPage() {
  return (
    <LayoutV2
      title="Marketplace"
      showCommunitySearch
      showCommunityFilters
      selectedCommunityFilter="latest"
    >
      <MarketplaceIntro
        eyebrow="Latest"
        title="Just published"
        description="The newest files from the community, as they're shared."
      />
      <CommunityView isFeatured={false} />
    </LayoutV2>
  );
}
